import { BoxProps, ColorOptions, TextProps } from '@jfs/ui-new'
import { ViewStyle } from 'react-native'

const defaultStyle = {
  underlayColor: 'HALF_WHITE',

  textStyle: {
    fontSize: 12,
    fontWeight: '500',
  } as TextProps,

  viewStyle: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingRight: 6,
    // paddingVertical: 3,
  } as BoxProps,

  item: {
    padding: 4,
    alignItems: 'center',
    justifyContent: 'center',
  } as BoxProps,

  states: {
    normal: {
      iconStyle: {
        color: 'DARK_GREY',
        size: 14,
        fontWeight: '800',
      } as TextProps,

      textStyle: {
        color: 'PRIMARY_GREY',
        fontSize: 12,
        fontWeight: '500',
      } as TextProps,

      item: {
        backgroundColor: 'WHITE',
        borderBottomColor: 'WHITE',
        borderBottomWidth: 1,
      } as BoxProps,
    },

    selected: {
      iconStyle: {
        color: 'PRIMARY',
        size: 14,
        fontWeight: '800',
      } as TextProps,

      textStyle: {
        color: 'PRIMARY',
      } as TextProps,

      item: {
        backgroundColor: 'WHITE_30',
        borderBottomColor: 'PRIMARY',
        borderBottomWidth: 1,
      } as BoxProps,
    },
  },
}

const hightLightStyle = {
  ...defaultStyle,
  textStyle: {
    fontSize: 12,
    fontWeight: '600',
    color: 'BRAND_PRIMARY_RED',
  } as TextProps,
  item: {
    paddingVertical: 12,
    paddingHorizontal: 8,
    alignItems: 'center',
  } as BoxProps,
  states: {
    ...defaultStyle.states,
    normal: {
      iconStyle: {
        color: 'DARK_GREY',
        size: 14,
        fontWeight: '800',
      } as TextProps,

      textStyle: {
        color: 'GRAY_BORDER',
        fontSize: 12,
        fontWeight: '600',
      } as TextProps,

      item: {
        backgroundColor: 'WHITE',
        borderBottomColor: 'WHITE',
        borderBottomWidth: 1,
        p: 15,
      } as BoxProps,
    },
    selected: {
      iconStyle: {
        color: 'PRIMARY',
        size: 14,
      },

      textStyle: {
        color: 'PRIMARY',
      } as TextProps,

      item: {
        backgroundColor: 'PRIMARY_LIGHT',
      } as ViewStyle,
    },
  },
}

const recentPaymentsStyle = {
  ...defaultStyle,
  textStyle: {
    fontSize: 12,
    fontWeight: '500',
    color: 'LIGHT_BLACK',
  } as TextProps,
  item: {
    padding: 15,
    alignItems: 'center',
  } as BoxProps,
  states: {
    ...defaultStyle.states,
    normal: {
      iconStyle: {
        color: 'DARK_GREY',
        size: 19,
        fontWeight: '800',
      } as TextProps,

      textStyle: {
        color: 'PRIMARY_GREY',
        fontSize: 12,
        type: 'caption',
        fontWeight: '600',
      } as TextProps,

      item: {
        backgroundColor: 'WHITE',
      } as BoxProps,
    },

    selected: {
      iconStyle: {
        color: 'BLUE_SHADE_PRIMARY',
        size: 14,
      },

      textStyle: {
        color: 'BLUE_SHADE_PRIMARY',
        fontSize: 12,
        fontWeight: '600',
        type: 'caption',
      } as TextProps,

      item: {
        borderBottomColor: 'BLUE_SHADE_PRIMARY',
        borderBottomWidth: 2,
        bg: '#0070B614' as ColorOptions,
      } as BoxProps,
    },
  },
}

const profileStyle = {
  ...defaultStyle,
  textStyle: {
    fontSize: 12,
    fontWeight: '500',
    color: 'PRIMARY_GREY',
  } as TextProps,
  item: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    alignItems: 'center',
  } as BoxProps,
  states: {
    ...defaultStyle.states,
    normal: {
      iconStyle: {
        color: 'DARK_GREY',
        size: 14,
        fontWeight: '600',
      } as TextProps,

      textStyle: {
        color: '#909090' as ColorOptions,
        fontSize: 12,
        fontWeight: '600',
      } as TextProps,

      item: {
        backgroundColor: 'WHITE',
        borderBottomColor: 'WHITE',
        borderBottomWidth: 1,
        p: 20,
      } as BoxProps,
    },
    selected: {
      iconStyle: {
        color: 'PRIMARY',
        size: 14,
      },

      textStyle: {
        color: 'PRIMARY',
        fontWeight: '600',
        fontSize: 12,
      } as TextProps,

      item: {
        pv: 16,
        ph: 20,
        backgroundColor: '#F0F8FB' as ColorOptions,
        borderBottomColor: 'PRIMARY',
        borderBottomWidth: 2,
      } as BoxProps,
    },
  },
}

const TAB_GREY = '#888888' as ColorOptions
const PRIMARY_HIGHLIGHT = 'rgba(0, 112, 182, 0.08)' as ColorOptions
const bulkEntityStyle = {
  ...recentPaymentsStyle,
  textStyle: {
    fontSize: 12,
    fontWeight: '500',
    color: 'GREY_MATTE',
  } as TextProps,
  item: {
    padding: 15,
    alignItems: 'center',
  } as BoxProps,
  states: {
    ...defaultStyle.states,
    normal: {
      iconStyle: {
        color: 'DARK_GREY',
        size: 19,
        fontWeight: '800',
      } as TextProps,

      textStyle: {
        color: TAB_GREY,
        fontSize: 12,
        type: 'caption',
        fontFamily: 'jiotype-medium',
      } as TextProps,

      item: {
        backgroundColor: 'WHITE',
      } as BoxProps,
    },

    selected: {
      iconStyle: {
        color: 'PRIMARY',
        size: 14,
      },

      textStyle: {
        color: 'BLUE_SHADE_PRIMARY',
        fontSize: 12,
        type: 'caption',
        fontFamily: 'jiotype-medium',
      } as TextProps,

      item: {
        borderBottomWidth: 2,
        bg: PRIMARY_HIGHLIGHT as ColorOptions,
        borderBottomColor: 'BLUE_SHADE_PRIMARY' as ColorOptions,
      } as BoxProps,
    },
  },
}

const documentationStyle = {
  ...defaultStyle,
  textStyle: {
    fontSize: 12,
    fontWeight: '500',
    color: 'LIGHT_BLACK',
  } as TextProps,
  item: {
    padding: 15,
    alignItems: 'center',
  } as BoxProps,
  states: {
    // ...defaultStyle.states,
    normal: {
      iconStyle: {
        color: 'BLUE_SHADE_PRIMARY',
        size: 14,
      },

      textStyle: {
        color: 'WHITE',
        fontSize: 12,
        fontWeight: '600',
        type: 'caption',
      } as TextProps,

      item: {
        borderBottomColor: 'TRANSPARENT',
        borderBottomWidth: 0,
        bg: '#0070B614' as ColorOptions,
      } as BoxProps,
    },

    selected: {
      iconStyle: {
        color: 'DARK_GREY',
        size: 19,
        fontWeight: '800',
      } as TextProps,

      textStyle: {
        color: 'BLACK_21',
        fontSize: 12,
        type: 'caption',
        fontWeight: '600',
      } as TextProps,

      item: {
        backgroundColor: 'WHITE',
      } as BoxProps,
    },
  },
}

const styles = {
  default: defaultStyle,
  highlights: hightLightStyle,
  recentPayments: recentPaymentsStyle,
  profile: profileStyle,
  bulkEntity: bulkEntityStyle,
  documentation: documentationStyle,
  arrow: {
    ...defaultStyle,
    underlayColor: 'GREY_SEPARATOR',
    item: {
      ...defaultStyle.item,
      padding: 0,
      width: 30,
      paddingLeft: 12,
    },
    states: {
      ...defaultStyle.states,
      normal: {
        ...defaultStyle.states.normal,

        iconStyle: {
          color: 'BLACK',
          size: 16,
          fontWeight: 700,
        },

        textStyle: {
          color: 'BLACK',
          fontSize: 12,
          fontWeight: '600',
        } as TextProps,

        item: {
          backgroundColor: 'WHITE',
          borderBottomColor: 'WHITE',
          borderBottomWidth: 0,
        } as BoxProps,
      },

      selected: {
        iconStyle: {
          color: 'GREY_SEPARATOR',
          size: 16,
          fontWeight: 700,
        },

        textStyle: {
          color: 'BLACK',
          fontSize: 12,
          fontWeight: '700',
        } as TextProps,

        item: {
          backgroundColor: 'WHITE',
          borderBottomWidth: 0,
        } as BoxProps,
      },
    },
  },
}

export default styles
